/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { useDispatch } from "react-redux";

// Material UI
import { makeStyles } from "@material-ui/core/styles";
import { ButtonBase } from "@material-ui/core";

// Components
import Text, { types } from "../../components/Text/Text";
import VideoModal from "../../components/VideoModal/VideoModal";

// Assets
import play from "../../assets/backgrounds/play.svg";
import bgVideo from "../../assets/backgrounds/getConnectedPage/bgVideo.png";
import phoneApp from "../../assets/backgrounds/phones-app-video.png";

// Config
import { getText } from "../../utils/textUtils";
import { language } from "../../languages/Languages";
import styles from "../../config/styles";

// Actions
import { openVideoModal } from "../../state/TutorialVideos/actions";

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      padding: "48px 0"
    }
  },
  titleWrapper: {
    display: "none",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex"
    }
  },
  titleMobile: {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
    fontWeight: 800,
    width: "20ch",
    textAlign: "center",
    textTransform: "capitalize",
    marginBottom: theme.spacing(3),
    padding: "0 12px"
  },
  howItWorks: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    backgroundImage: `url(${bgVideo})`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
    color: "white",
    height: 925,
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      height: "56.25vw"
    }
  },
  play: {
    height: "15vw",
    width: "15vw",
    opacity: 0.9,
    backgroundImage: `url(${play})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    cursor: "pointer",
    transition: "all .1s ease-in-out",
    borderRadius: "100%",
    [`&:hover`]: {
      transform: "scale(1.1)",
      opacity: 1
    }
  },
  playContainer: {
    position: "absolute"
  },
  info: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "40%"
  },
  title: {
    color: theme.palette.secondary.contrastText,
    fontSize: "99px",
    width: "11ch",
    marginRight: "100px",
    [theme.breakpoints.down("md")]: {
      fontSize: 72,
      color: "inherit"
    },
    [theme.breakpoints.down(1440)]: {
      fontSize: 56,
      color: "inherit"
    },
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  phones: {
    display: "flex",
    width: "40%",
    height: 900,
    ...styles.mixins.icon,
    backgroundImage: `url(${phoneApp})`,
    transform: " translateX(150px)",
    [theme.breakpoints.down("md")]: {
      height: 600,
      transform: " translateX(70px)"
    },
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  }
}));

const HowItWorksMini = ({ className, ...rest }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { campaign } = language.pages.home;
  const { title } = campaign;

  const playVideo = () => dispatch(openVideoModal());

  return (
    <section className={classes.root}>
      <div className={classes.titleWrapper}>
        <Text
          className={classes.titleMobile}
          type={types.sectionTitle}
          component="h2"
        >
          {getText(title)}
        </Text>
      </div>
      <div className={classes.howItWorks} {...rest}>
        <div className={classes.playContainer}>
          <ButtonBase className={classes.play} onClick={playVideo} />
        </div>
        <div className={classes.info}>
          <Text
            className={classes.title}
            type={types.campaignTitle}
            component="h2"
          >
            {getText(title)}
          </Text>
        </div>
        <div className={classes.phones} />
        <VideoModal />
      </div>
    </section>
  );
};

export default HowItWorksMini;
